<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        :clearable="clearable"
        :label="label"
        dense
        outlined
        readonly
        hide-details
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable range :max="max">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  props: {
    label: {
      type: String,
      default: "Date Range",
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      date: [],
    };
  },
  computed: {
    max() {
      return moment().format("YYYY-MM-DD");
    },
    dateRangeText() {
      let dates = this.date;
      let date = [];
      if (dates[0]) {
        date.push(moment(dates[0]).format("MM/DD/YY"));
      }
      if (dates[1]) {
        date.push(moment(dates[1]).format("MM/DD/YY"));
      }
      return date.join(" - ");
    },
  },
  watch: {
    $route() {
      this.init();
    },
    value(val) {
      this.date = val;
    },
    date(val) {
      if (val) {
        this.$emit("input", val);
      } else {
        this.$emit("input", []);
      }
    },
  },
  methods: {
    init() {
      const vm = this;
      this.date = this.value;
      if (vm.date.length === 0) {
        let start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        let end = moment()
          .endOf("day")
          .format("YYYY-MM-DD");
        vm.date.push(start);
        vm.date.push(end);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
